import { SampleData } from "../../stores/Sample";
import { AlignmentOptions } from "../../stores/Search";
import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";
import { SamplesList } from "../SamplesList";

function Sample196593() {
  const samplesList: SampleData[] = notableSamples.map(
    (sample) =>
      new SampleData(
        sample.text,
        [...sample.text],
        sample.activations,
        sample.normalizedActivation,
        sample.targetIdx,
        sample.absoluteTokenIdx,
        sample.modelId
      )
  );

  return (
    <>
      <h4>
        <SampleAnchor modelId="baby-v1" sampleId="196593" />
        <span> - </span>
        <SampleQuote text="neighbour's wife" targetIdx={9} />
      </h4>
      <p>
        The apostrophe in this sample triggers two positional features,&nbsp;
        <FeatureAnchor modelId="baby-v1" sampleId="196593" featureKey="1.0.2296" compact />{" "}
        and&nbsp;
        <FeatureAnchor modelId="baby-v1" sampleId="196593" featureKey="1.0.5716" compact />. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="196593" featureKey="1.0.2296" compact /> has
        activation peaks surrounding eight specific locations with the last peak being 15 tokens
        from the end of a sequence. Feature{" "}
        <FeatureAnchor modelId="baby-v1" sampleId="196593" featureKey="1.0.5716" compact /> starts
        with its lowest activation values at the beginning of a sequence and ends with its highest
        values. Together, these features fire most strongly at the exact location of the apostrophe
        in this sample.
      </p>
      <figure>
        <figcaption>Sinusoidal Positional Encodings</figcaption>
        <SamplesList
          samples={samplesList}
          alignment={AlignmentOptions.Right}
          rightPadding={20}
          hideActivation={true}
          showIcon={true}
        />
      </figure>
    </>
  );
}

const notableSamples = [
  {
    text: "down to sleep.\n\nSecond Watchman:\nWhat, will he not to bed?\n\nFirst Watchman:\nWhy, no; for he hath made a solemn vow\nNever to lie and take his natural rest\nTill Warwick or himself be quite suppress'd.\n\nSecond Watchman:\nTo-morrow then belike shall be the day,",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.08, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0.142, 0.179, 0.194, 0.265, 0.15, 0.04, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.039, 0.139, 0.214, 0.169, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.081, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.114, 0.231, 0.216, 0.105, 0.08, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.09, 0.1, 0.121, 0.07, 0, 0, 0, 0, 0, 0, 0, 0.09, 0.157,
      0.146, 0.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.078, 0.176, 0.238, 0.155, 0.048,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.293040293040293, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.5201465201465201, 0.6556776556776556, 0.7106227106227105,
      0.9706959706959707, 0.5494505494505494, 0.1465201465201465, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.14285714285714285, 0.5091575091575091, 0.7838827838827838, 0.6190476190476191,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2967032967032967, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.41758241758241754, 0.8461538461538461, 0.7912087912087912,
      0.3846153846153846, 0.293040293040293, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.3296703296703296, 0.3663003663003663, 0.4432234432234432, 0.25641025641025644, 0, 0, 0, 0,
      0, 0, 0, 0.3296703296703296, 0.575091575091575, 0.5347985347985347, 0.3663003663003663, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2857142857142857, 0.6446886446886446,
      0.8717948717948717, 0.5677655677655677, 0.1758241758241758, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 669425,
    modelId: "baby",
  },
  {
    text: "n his visage, and that all the walls\nWith painted imagery had said at once\n'Jesu preserve thee! welcome, Bolingbroke!'\nWhilst he, from the one side to the other turning,\nBareheaded, lower than his proud steed's neck,\nBespake them thus: 'I thank you, countr",
    activations: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.081, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0.141, 0.18, 0.196, 0.265, 0.151, 0.042, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.039, 0.139, 0.213, 0.169, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.083, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.112, 0.231, 0.215, 0.103, 0.08, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.091, 0.1, 0.119, 0.07, 0, 0, 0, 0, 0, 0, 0, 0.089, 0.159,
      0.144, 0.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.077, 0.176, 0.238, 0.155, 0.049,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    ],
    normalizedActivation: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.2967032967032967, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0.5164835164835164, 0.6593406593406592, 0.717948717948718,
      0.9706959706959707, 0.553113553113553, 0.15384615384615385, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0.14285714285714285, 0.5091575091575091, 0.7802197802197801, 0.6190476190476191,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.304029304029304, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.41025641025641024, 0.8461538461538461, 0.7875457875457875,
      0.3772893772893772, 0.293040293040293, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0.3333333333333333, 0.3663003663003663, 0.43589743589743585, 0.25641025641025644, 0, 0, 0, 0,
      0, 0, 0, 0.32600732600732596, 0.5824175824175823, 0.5274725274725274, 0.3663003663003663, 0,
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.28205128205128205, 0.6446886446886446,
      0.8717948717948717, 0.5677655677655677, 0.1794871794871795, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 423153,
    modelId: "baby",
  },
  {
    text: " she's a traitor and Camillo is\nA federary with her, and one that knows\nWhat she should shame to know herself\nBut with her most vile principal, that she's\nA bed-swerver, even as bad as those\nThat vulgars give bold'st titles, ay, and privy\nTo this their lat",
    activations: [
      0.329, 0.385, 0.416, 0.408, 0.435, 0.408, 0.408, 0.446, 0.42, 0.39, 0.403, 0.425, 0.398,
      0.376, 0.398, 0.395, 0.429, 0.434, 0.435, 0.436, 0.431, 0.415, 0.457, 0.421, 0.44, 0.455,
      0.453, 0.43, 0.447, 0.451, 0.452, 0.509, 0.487, 0.467, 0.424, 0.456, 0.439, 0.463, 0.463,
      0.505, 0.491, 0.489, 0.478, 0.47, 0.475, 0.447, 0.439, 0.421, 0.428, 0.441, 0.441, 0.495,
      0.48, 0.485, 0.462, 0.451, 0.46, 0.45, 0.505, 0.492, 0.48, 0.484, 0.506, 0.526, 0.518, 0.524,
      0.512, 0.552, 0.511, 0.504, 0.506, 0.539, 0.521, 0.535, 0.56, 0.532, 0.524, 0.524, 0.529,
      0.527, 0.499, 0.488, 0.501, 0.493, 0.536, 0.534, 0.541, 0.543, 0.543, 0.54, 0.544, 0.527,
      0.558, 0.549, 0.544, 0.517, 0.519, 0.479, 0.522, 0.512, 0.538, 0.548, 0.562, 0.575, 0.565,
      0.547, 0.586, 0.57, 0.552, 0.574, 0.545, 0.559, 0.548, 0.548, 0.545, 0.596, 0.603, 0.592,
      0.578, 0.588, 0.59, 0.615, 0.633, 0.62, 0.591, 0.613, 0.637, 0.623, 0.611, 0.631, 0.613,
      0.639, 0.631, 0.59, 0.638, 0.635, 0.623, 0.592, 0.604, 0.579, 0.634, 0.637, 0.658, 0.637,
      0.639, 0.662, 0.651, 0.606, 0.629, 0.656, 0.658, 0.653, 0.673, 0.647, 0.692, 0.674, 0.635,
      0.585, 0.642, 0.641, 0.641, 0.661, 0.636, 0.674, 0.684, 0.696, 0.713, 0.703, 0.721, 0.695,
      0.706, 0.708, 0.711, 0.716, 0.707, 0.713, 0.694, 0.698, 0.678, 0.756, 0.718, 0.717, 0.728,
      0.719, 0.734, 0.747, 0.739, 0.72, 0.726, 0.744, 0.748, 0.724, 0.725, 0.741, 0.699, 0.706,
      0.724, 0.731, 0.747, 0.716, 0.755, 0.758, 0.739, 0.75, 0.752, 0.784, 0.771, 0.77, 0.784,
      0.743, 0.762, 0.779, 0.768, 0.804, 0.797, 0.809, 0.808, 0.798, 0.799, 0.773, 0.787, 0.807,
      0.809, 0.855, 0.81, 0.842, 0.809, 0.839, 0.831, 0.843, 0.842, 0.845, 0.83, 0.806, 0.858,
      0.851, 0.856, 0.849, 0.871, 0.891, 0.879, 0.906, 0.88, 0.89, 0.904, 0.895, 0.899, 0.91, 0.941,
      0.965, 0.96, 0.959, 0.93, 0.898, 0.935, 0.881,
    ],
    normalizedActivation: [
      0.31665062560154, 0.370548604427334, 0.4003849855630414, 0.39268527430221367,
      0.41867179980750724, 0.39268527430221367, 0.39268527430221367, 0.42925890279114537,
      0.40423484119345526, 0.37536092396535137, 0.3878729547641964, 0.40904716073147257,
      0.38306063522617906, 0.3618864292589028, 0.38306063522617906, 0.3801732435033687,
      0.41289701636188647, 0.4177093358999038, 0.41867179980750724, 0.4196342637151107,
      0.4148219441770934, 0.39942252165543796, 0.4398460057747835, 0.4051973051010587,
      0.4234841193455246, 0.4379210779595766, 0.43599615014436965, 0.41385948026948993,
      0.43022136669874883, 0.4340712223291627, 0.4350336862367662, 0.48989412897016366,
      0.4687199230028874, 0.44947064485081817, 0.4080846968238691, 0.43888354186718004,
      0.4225216554379211, 0.44562078922040427, 0.44562078922040427, 0.4860442733397498,
      0.4725697786333013, 0.4706448508180944, 0.46005774783445624, 0.4523580365736285,
      0.4571703561116458, 0.43022136669874883, 0.4225216554379211, 0.4051973051010587,
      0.411934552454283, 0.42444658325312806, 0.42444658325312806, 0.47641963426371514,
      0.46198267564966317, 0.4667949951876805, 0.4446583253128008, 0.4340712223291627,
      0.4427333974975939, 0.4331087584215592, 0.4860442733397498, 0.47353224254090476,
      0.46198267564966317, 0.465832531280077, 0.48700673724735327, 0.5062560153994226,
      0.49855630413859486, 0.5043310875842156, 0.49278152069297404, 0.5312800769971127,
      0.4918190567853706, 0.48508180943214635, 0.48700673724735327, 0.5187680461982677,
      0.5014436958614052, 0.5149181905678538, 0.5389797882579405, 0.5120307988450433,
      0.5043310875842156, 0.5043310875842156, 0.5091434071222329, 0.507218479307026,
      0.480269489894129, 0.46968238691049086, 0.4821944177093359, 0.4744947064485082,
      0.5158806544754573, 0.5139557266602504, 0.5206929740134746, 0.5226179018286815,
      0.5226179018286815, 0.5197305101058711, 0.523580365736285, 0.507218479307026,
      0.5370548604427335, 0.5283926852743023, 0.523580365736285, 0.4975938402309914,
      0.4995187680461983, 0.4610202117420597, 0.5024061597690087, 0.49278152069297404,
      0.5178055822906642, 0.5274302213666988, 0.5409047160731474, 0.5534167468719923,
      0.5437921077959577, 0.5264677574590954, 0.5640038498556305, 0.548604427333975,
      0.5312800769971127, 0.5524542829643888, 0.5245428296438884, 0.538017324350337,
      0.5274302213666988, 0.5274302213666988, 0.5245428296438884, 0.5736284889316651,
      0.5803657362848893, 0.5697786333012512, 0.5563041385948027, 0.5659287776708374,
      0.5678537054860443, 0.591915303176131, 0.6092396535129934, 0.5967276227141483,
      0.5688161693936478, 0.589990375360924, 0.6130895091434072, 0.5996150144369586,
      0.5880654475457171, 0.6073147256977863, 0.589990375360924, 0.6150144369586141,
      0.6073147256977863, 0.5678537054860443, 0.6140519730510107, 0.6111645813282003,
      0.5996150144369586, 0.5697786333012512, 0.5813282001924928, 0.5572666025024061,
      0.6102021174205968, 0.6130895091434072, 0.63330125120308, 0.6130895091434072,
      0.6150144369586141, 0.6371511068334939, 0.6265640038498557, 0.5832531280076997,
      0.6053897978825794, 0.631376323387873, 0.63330125120308, 0.6284889316650626,
      0.6477382098171319, 0.6227141482194418, 0.6660250240615977, 0.6487006737247354,
      0.6111645813282003, 0.563041385948027, 0.6179018286814245, 0.616939364773821,
      0.616939364773821, 0.6361886429258904, 0.6121270452358037, 0.6487006737247354,
      0.6583253128007701, 0.6698748796920115, 0.6862367661212705, 0.6766121270452358,
      0.6939364773820982, 0.6689124157844081, 0.6794995187680463, 0.6814244465832532,
      0.6843118383060636, 0.6891241578440809, 0.6804619826756497, 0.6862367661212705,
      0.6679499518768046, 0.6717998075072185, 0.6525505293551492, 0.7276227141482196,
      0.6910490856592878, 0.6900866217516843, 0.7006737247353224, 0.6920115495668913,
      0.7064485081809433, 0.7189605389797883, 0.7112608277189606, 0.6929740134744947,
      0.6987487969201155, 0.7160731472569779, 0.7199230028873917, 0.6968238691049086,
      0.697786333012512, 0.7131857555341675, 0.6727622714148219, 0.6794995187680463,
      0.6968238691049086, 0.7035611164581329, 0.7189605389797883, 0.6891241578440809,
      0.726660250240616, 0.7295476419634265, 0.7112608277189606, 0.7218479307025987,
      0.7237728585178056, 0.7545717035611166, 0.7420596727622715, 0.741097208854668,
      0.7545717035611166, 0.7151106833493744, 0.7333974975938403, 0.7497593840230992,
      0.7391722810394611, 0.7738209817131858, 0.7670837343599616, 0.7786333012512032,
      0.7776708373435998, 0.768046198267565, 0.7690086621751685, 0.7439846005774784,
      0.757459095283927, 0.7767083734359963, 0.7786333012512032, 0.8229066410009626,
      0.7795957651588067, 0.8103946102021174, 0.7786333012512032, 0.8075072184793071,
      0.7998075072184794, 0.8113570741097209, 0.8103946102021174, 0.8132820019249278,
      0.7988450433108759, 0.7757459095283928, 0.8257940327237729, 0.8190567853705486,
      0.823869104908566, 0.8171318575553417, 0.8383060635226179, 0.8575553416746873,
      0.8460057747834457, 0.8719923002887393, 0.8469682386910492, 0.8565928777670838,
      0.8700673724735324, 0.8614051973051011, 0.865255052935515, 0.8758421559191532,
      0.9056785370548605, 0.9287776708373436, 0.9239653512993263, 0.9230028873917229,
      0.8950914340712225, 0.8642925890279115, 0.8999037536092398, 0.8479307025986527,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 738037,
    modelId: "baby",
  },
  {
    text: "ife of Rome!\nCall all your tribes together, praise the gods,\nAnd make triumphant fires; strew flowers before them:\nUnshout the noise that banish'd Marcius,\nRepeal him with the welcome of his mother;\nCry 'Welcome, ladies, welcome!'\n\nAll:\nWelcome, ladies, We",
    activations: [
      0.337, 0.367, 0.416, 0.398, 0.4, 0.391, 0.408, 0.455, 0.402, 0.382, 0.408, 0.421, 0.415,
      0.372, 0.442, 0.393, 0.431, 0.407, 0.443, 0.44, 0.433, 0.421, 0.432, 0.414, 0.444, 0.456,
      0.45, 0.446, 0.451, 0.451, 0.424, 0.492, 0.477, 0.467, 0.444, 0.428, 0.432, 0.463, 0.457,
      0.489, 0.496, 0.493, 0.507, 0.481, 0.435, 0.453, 0.456, 0.43, 0.415, 0.441, 0.436, 0.464,
      0.489, 0.468, 0.443, 0.444, 0.442, 0.466, 0.483, 0.512, 0.506, 0.492, 0.515, 0.498, 0.52,
      0.514, 0.547, 0.524, 0.539, 0.514, 0.508, 0.517, 0.536, 0.537, 0.524, 0.501, 0.533, 0.554,
      0.538, 0.516, 0.499, 0.471, 0.5, 0.516, 0.534, 0.527, 0.545, 0.543, 0.543, 0.528, 0.522,
      0.546, 0.538, 0.549, 0.525, 0.537, 0.501, 0.479, 0.513, 0.534, 0.545, 0.548, 0.521, 0.575,
      0.54, 0.533, 0.58, 0.577, 0.573, 0.546, 0.548, 0.556, 0.54, 0.574, 0.582, 0.627, 0.623, 0.578,
      0.587, 0.561, 0.593, 0.609, 0.633, 0.628, 0.618, 0.626, 0.639, 0.641, 0.59, 0.631, 0.607,
      0.639, 0.631, 0.62, 0.643, 0.653, 0.603, 0.604, 0.564, 0.638, 0.626, 0.643, 0.625, 0.647,
      0.658, 0.651, 0.625, 0.608, 0.655, 0.664, 0.637, 0.652, 0.668, 0.647, 0.695, 0.695, 0.669,
      0.626, 0.6, 0.652, 0.665, 0.668, 0.646, 0.673, 0.688, 0.683, 0.704, 0.688, 0.701, 0.693,
      0.706, 0.705, 0.699, 0.707, 0.716, 0.687, 0.687, 0.707, 0.712, 0.718, 0.702, 0.707, 0.712,
      0.724, 0.716, 0.728, 0.729, 0.748, 0.739, 0.73, 0.722, 0.692, 0.698, 0.713, 0.71, 0.716,
      0.725, 0.722, 0.77, 0.718, 0.734, 0.754, 0.743, 0.767, 0.755, 0.785, 0.77, 0.749, 0.766,
      0.764, 0.789, 0.806, 0.77, 0.79, 0.827, 0.809, 0.816, 0.81, 0.786, 0.804, 0.785, 0.787, 0.823,
      0.829, 0.798, 0.798, 0.798, 0.819, 0.854, 0.833, 0.85, 0.873, 0.835, 0.841, 0.856, 0.868,
      0.879, 0.842, 0.854, 0.871, 0.885, 0.888, 0.872, 0.891, 0.924, 0.899, 0.901, 0.938, 0.93,
      0.964, 0.961, 0.95, 0.959, 0.896, 0.902, 0.893,
    ],
    normalizedActivation: [
      0.3243503368623677, 0.35322425409047165, 0.4003849855630414, 0.38306063522617906,
      0.384985563041386, 0.37632338787295483, 0.39268527430221367, 0.4379210779595766,
      0.3869104908565929, 0.3676612127045236, 0.39268527430221367, 0.4051973051010587,
      0.39942252165543796, 0.35803657362848895, 0.4254090471607315, 0.37824831568816175,
      0.4148219441770934, 0.3917228103946102, 0.426371511068335, 0.4234841193455246,
      0.4167468719923003, 0.4051973051010587, 0.41578440808469685, 0.39846005774783444,
      0.42733397497593845, 0.43888354186718004, 0.4331087584215592, 0.42925890279114537,
      0.4340712223291627, 0.4340712223291627, 0.4080846968238691, 0.47353224254090476,
      0.4590952839268528, 0.44947064485081817, 0.42733397497593845, 0.411934552454283,
      0.41578440808469685, 0.44562078922040427, 0.4398460057747835, 0.4706448508180944,
      0.4773820981713186, 0.4744947064485082, 0.48796920115495673, 0.4629451395572666,
      0.41867179980750724, 0.43599615014436965, 0.43888354186718004, 0.41385948026948993,
      0.39942252165543796, 0.42444658325312806, 0.4196342637151107, 0.44658325312800773,
      0.4706448508180944, 0.45043310875842163, 0.426371511068335, 0.42733397497593845,
      0.4254090471607315, 0.4485081809432147, 0.46487006737247355, 0.49278152069297404,
      0.48700673724735327, 0.47353224254090476, 0.4956689124157845, 0.4793070259865255,
      0.5004812319538018, 0.494706448508181, 0.5264677574590954, 0.5043310875842156,
      0.5187680461982677, 0.494706448508181, 0.4889316650625602, 0.4975938402309914,
      0.5158806544754573, 0.5168431183830607, 0.5043310875842156, 0.4821944177093359,
      0.5129932627526469, 0.5332050048123196, 0.5178055822906642, 0.49663137632338794,
      0.480269489894129, 0.45332050048123196, 0.48123195380173245, 0.49663137632338794,
      0.5139557266602504, 0.507218479307026, 0.5245428296438884, 0.5226179018286815,
      0.5226179018286815, 0.5081809432146295, 0.5024061597690087, 0.5255052935514919,
      0.5178055822906642, 0.5283926852743023, 0.5052935514918191, 0.5168431183830607,
      0.4821944177093359, 0.4610202117420597, 0.4937439846005775, 0.5139557266602504,
      0.5245428296438884, 0.5274302213666988, 0.5014436958614052, 0.5534167468719923,
      0.5197305101058711, 0.5129932627526469, 0.5582290664100096, 0.5553416746871992,
      0.5514918190567853, 0.5255052935514919, 0.5274302213666988, 0.5351299326275265,
      0.5197305101058711, 0.5524542829643888, 0.5601539942252166, 0.6034648700673725,
      0.5996150144369586, 0.5563041385948027, 0.5649663137632339, 0.5399422521655439,
      0.5707410972088547, 0.5861405197305102, 0.6092396535129934, 0.6044273339749759,
      0.5948026948989413, 0.602502406159769, 0.6150144369586141, 0.616939364773821,
      0.5678537054860443, 0.6073147256977863, 0.5842155919153033, 0.6150144369586141,
      0.6073147256977863, 0.5967276227141483, 0.618864292589028, 0.6284889316650626,
      0.5803657362848893, 0.5813282001924928, 0.5428296438883542, 0.6140519730510107,
      0.602502406159769, 0.618864292589028, 0.6015399422521656, 0.6227141482194418,
      0.63330125120308, 0.6265640038498557, 0.6015399422521656, 0.5851780558229067,
      0.6304138594802695, 0.6390760346487008, 0.6130895091434072, 0.6275264677574591,
      0.6429258902791146, 0.6227141482194418, 0.6689124157844081, 0.6689124157844081,
      0.6438883541867181, 0.602502406159769, 0.5774783445620789, 0.6275264677574591,
      0.6400384985563042, 0.6429258902791146, 0.6217516843118384, 0.6477382098171319,
      0.6621751684311838, 0.6573628488931667, 0.6775745909528392, 0.6621751684311838,
      0.6746871992300288, 0.6669874879692012, 0.6794995187680463, 0.6785370548604427,
      0.6727622714148219, 0.6804619826756497, 0.6891241578440809, 0.6612127045235805,
      0.6612127045235805, 0.6804619826756497, 0.685274302213667, 0.6910490856592878,
      0.6756496631376323, 0.6804619826756497, 0.685274302213667, 0.6968238691049086,
      0.6891241578440809, 0.7006737247353224, 0.7016361886429259, 0.7199230028873917,
      0.7112608277189606, 0.7025986525505293, 0.6948989412897016, 0.6660250240615977,
      0.6717998075072185, 0.6862367661212705, 0.6833493743984601, 0.6891241578440809,
      0.697786333012512, 0.6948989412897016, 0.741097208854668, 0.6910490856592878,
      0.7064485081809433, 0.7256977863330125, 0.7151106833493744, 0.7382098171318576,
      0.726660250240616, 0.75553416746872, 0.741097208854668, 0.7208854667949952,
      0.7372473532242542, 0.7353224254090472, 0.7593840230991339, 0.7757459095283928,
      0.741097208854668, 0.7603464870067373, 0.7959576515880654, 0.7786333012512032,
      0.7853705486044273, 0.7795957651588067, 0.7564966313763235, 0.7738209817131858,
      0.75553416746872, 0.757459095283927, 0.7921077959576516, 0.7978825794032725,
      0.768046198267565, 0.768046198267565, 0.768046198267565, 0.7882579403272377,
      0.8219441770933591, 0.8017324350336863, 0.8180943214629451, 0.8402309913378249,
      0.8036573628488932, 0.809432146294514, 0.823869104908566, 0.8354186717998076,
      0.8460057747834457, 0.8103946102021174, 0.8219441770933591, 0.8383060635226179,
      0.8517805582290665, 0.8546679499518769, 0.8392685274302214, 0.8575553416746873,
      0.8893166506256016, 0.865255052935515, 0.8671799807507219, 0.9027911453320501,
      0.8950914340712225, 0.9278152069297402, 0.9249278152069298, 0.9143407122232916,
      0.9230028873917229, 0.8623676612127046, 0.8681424446583254, 0.8594802694898942,
    ],
    targetIdx: -1,
    absoluteTokenIdx: 147199,
    modelId: "baby",
  },
];

export { Sample196593 };
